module.exports = __webpack_public_path__ + "static/media/brandInvestec.a4e5e6e7.jpg";